import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core'

const initState = {
    displayGameTypeCode: 'all',
    gameCode: 'all',
    displayGameTypeCodeList: [],
    gameList: [],
    gameMaker: 'all',
    gameMakerList: {
        0: 'R88',
        1: '好路',
        2: 'Turbo Games'
    }
}

class GameSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'GameSelect', options)
        }

        this.state = initState
    }

    componentDidMount() {
        this.init()
        this.props.onRef(this)
    }
    

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    init() {
        this.setState({
            ...initState,
        },() => {
            this.getGameList()
        })
    }
    /** 取遊戲列表時篩選開發商 */
    getGameList() {
        let gameList = utils.deepCopy(this.props.dataService.gameList).filter(item => {
            return this.state.gameMaker === 'all' || String(item.maker) === String(this.state.gameMaker)
        })
        /** 客製化篩選條件 */
        if (this.props.options && typeof this.props.options.gameListFilter === 'function') {
            gameList = gameList.filter(this.props.options.gameListFilter)
        }
        this.setState({
            gameList,
        }, () => {
            /** 執行遊戲分類 */
            this.gameGrouper(gameList)
        })
    }
    /** 遊戲分類 */
    gameGrouper(gameList) {
        const displayGameTypeCodeList = []
        gameList.forEach((elem) => {
            if (elem.is_register && !displayGameTypeCodeList.includes(elem.display_game_type_code_id)) {
                displayGameTypeCodeList.push(elem.display_game_type_code_id)
            }
        })
        this.setState({
            displayGameTypeCodeList,
        })
    }

    render() {
        return (
            <React.Fragment>
                <FormControl
                    className={
                        this.props.options && this.props.options.gameMakerSelect ? this.props.classes.formControl : this.props.classes.hide
                    }>
                    <InputLabel>{this.t('developer')}</InputLabel>
                    <Select
                        value={this.state.gameMaker}
                        onChange={(event) =>
                            this.setState({
                                gameMaker: event.target.value,
                                displayGameTypeCode: 'all',
                                gameCode: 'all',
                            }, () => {
                                this.getGameList()
                            })
                        }>
                        <MenuItem value="all">{this.t('treeDataAll')}</MenuItem>
                        {
                            Object.entries(this.state.gameMakerList).map(([key, value]) => {
                                return (
                                    <MenuItem value={key} key={key}>{value}</MenuItem>
                                )
                            })
                        }
                    </Select>
                </FormControl>
                <FormControl
                    className={
                        this.props.options && this.props.options.hideGameTypeSelect ? this.props.classes.hide : this.props.classes.formControl
                    }>
                    <InputLabel>{this.t('gameType')}</InputLabel>
                    <Select
                        value={this.state.displayGameTypeCode}
                        onChange={(event) =>
                            this.setState({
                                displayGameTypeCode: event.target.value,
                                gameCode: 'all',
                            })
                        }>
                        <MenuItem value="all">{this.t('allType')}</MenuItem>
                        {this.state.displayGameTypeCodeList.map((displayGameTypeCode) => {
                            return (
                                <MenuItem value={displayGameTypeCode} key={displayGameTypeCode}>
                                    {this.t(`GameType.${displayGameTypeCode}`)}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                <FormControl className={this.props.classes.formControl}>
                    <InputLabel>{this.t('gameName')}</InputLabel>
                    <Select
                        value={this.state.gameCode}
                        onChange={(event) =>
                            this.setState({
                                gameCode: event.target.value,
                            })
                        }>
                        <MenuItem value="all">{this.t('allGame')}</MenuItem>
                        {this.state.gameList
                            .filter(
                                (elem) =>
                                    elem['is_register'] &&
                                    (this.state.displayGameTypeCode === 'all' || elem['display_game_type_code_id'] === this.state.displayGameTypeCode) &&
                                    (!this.props.options?.gameOpenedList || this.props.options?.gameOpenedList.includes(elem.game_code))
                            )
                            .map((elem) => (
                                <MenuItem value={elem['game_code']} key={elem['game_code']}>
                                    {this.t(`GameName.${elem['game_code']}`)}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </React.Fragment>
        )
    }
}

GameSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    options: PropTypes.object,
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(GameSelect)
